import React from 'react';

const SvgDiscount = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4.897 9.8l4.902-4.897a.67.67 0 00.201-.47V.665C10 .299 9.7 0 9.335 0H5.561a.668.668 0 00-.47.198L.195 5.096a.666.666 0 000 .942l3.761 3.761c.26.26.68.26.94 0zm2.82-8.463a.665.665 0 11.941.94.665.665 0 01-.94-.94z" />
  </svg>
);

export default SvgDiscount;
